import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconEmail2Unread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconEmail2Unread"><Path d="M22 7.38379C22 8.0447 21.6273 8.64988 21.0371 8.94727L12.7871 13.1035C12.2919 13.353 11.7081 13.3529 11.2129 13.1035L3.5 9.21777V18.25C3.5 18.3881 3.61193 18.5 3.75 18.5H11.25C11.6642 18.5 12 18.8358 12 19.25C12 19.6642 11.6642 20 11.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75C2 4.7835 2.7835 4 3.75 4H20.25C21.2165 4.00004 22 4.78353 22 5.75V7.38379Z" fill="currentColor"/><Circle cx="19.5" cy="17.5" r="3.5" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Unread;
